"use client";

import { useEffect } from "react";

export type AiAssistantPageContext = {
  sailingId: string;
  title: string;
  quoteUrl: string;
};

export const AI_ASSISTANT_CONTEXT_EVENT = "cruisevoyage:assistant-context";

export function AiAssistantContext({
  sailingId,
  title,
  quoteUrl,
}: AiAssistantPageContext) {
  useEffect(() => {
    const context = { sailingId, title, quoteUrl };
    document.documentElement.dataset.aiSailingId = sailingId;
    document.documentElement.dataset.aiSailingTitle = title;
    document.documentElement.dataset.aiQuoteUrl = quoteUrl;
    window.dispatchEvent(
      new CustomEvent<AiAssistantPageContext>(AI_ASSISTANT_CONTEXT_EVENT, {
        detail: context,
      }),
    );
    return () => {
      delete document.documentElement.dataset.aiSailingId;
      delete document.documentElement.dataset.aiSailingTitle;
      delete document.documentElement.dataset.aiQuoteUrl;
      window.dispatchEvent(
        new CustomEvent<null>(AI_ASSISTANT_CONTEXT_EVENT, { detail: null }),
      );
    };
  }, [quoteUrl, sailingId, title]);

  return null;
}
